export const SCHEDULED_LISTING_IMAGE_BLUR_CLASS = "blur-md brightness-75";

export const SCHEDULED_LISTING_THUMB_BLUR_CLASS = "blur-xs brightness-75";
